<ng-template #linkForLocation>
    <shared-link [emphasis]="false" (onClick)="handleMoreStores($event)">View all stores</shared-link>
</ng-template>

<ng-template #linkForVenue>
    <shared-link [emphasis]="false" (onClick)="handleMoreStores($event)">View all available stores</shared-link>
</ng-template>


<ng-template #forLocation>
    <ng-template #headerRight>
        <projection-for-device [desktop]="linkForLocation"></projection-for-device>
    </ng-template>
    <shared-header type="3" marginBottom="xlg" [right]="headerRight">Your closest stores</shared-header>
</ng-template>

<ng-template #forVenue>
    <ng-template #headerRight>
        <projection-for-device [desktop]="linkForVenue"></projection-for-device>
    </ng-template>
    <shared-header marginBottom="xlg" [right]="headerRight" type="2">Popular stores available now</shared-header>
</ng-template>



<shared-locations-not-available *ngIf="(isLoadingLocations$ | async) === false && (locations$ | async)?.length === 0">
</shared-locations-not-available>

<ng-container *ngIf="(isLoadingLocations$ | async) === true || (locations$ | async)?.length > 0">
    <!-- Header -->
    <projection-for-location-mode [location]="forLocation" [venue]="forVenue">
    </projection-for-location-mode>

    <!-- List -->
    <shared-list-for-locations [loading]="(isLoadingLocations$ | async) === true" [locations]="locations$ | async"
        [placeholders]="3">
    </shared-list-for-locations>

    <!-- Pure link -->
    <ng-template #linksForMobile>
        <projection-for-location-mode [location]="linkForLocation" [venue]="linkForVenue">
        </projection-for-location-mode>
    </ng-template>
    <projection-for-device [mobile]="linksForMobile"></projection-for-device>
</ng-container>
